// extracted by mini-css-extract-plugin
export var table = "_vc-0";